import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

export const Column = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 2,
      key: "id",
      name: "ক্র: নং",
      render: (id: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {id}
        </Text>
      ),
    },
    {
      id: 3,
      key: "employeeCode",
      name: <Text className="text-nowrap">আইডি নম্বর</Text>,
      render: (employeeCode: string) => (
        <Text color="subtitle1">{employeeCode}</Text>
      ),
    },
    {
      id: 4,
      key: "employeeName",
      name: <Text className="text-nowrap">কর্মচারীর নাম</Text>,
      render: (employeeName: string) => (
        <Text color="subtitle1">{employeeName}</Text>
      ),
    },

    {
      id: 5,
      key: "lastUnitName",
      name: <Text className="text-nowrap">সর্বশেষ ইউনিটের নাম</Text>,
      render: (lastUnitName: string) => (
        <Text color="subtitle1">{lastUnitName}</Text>
      ),
    },
    {
      id: 6,
      key: "lastPositionName",
      name: "সর্বশেষ পদমর্যাদা",
      render: (lastPositionName: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {lastPositionName}
        </Text>
      ),
    },
    {
      id: 7,
      key: "releaseDate",
      name: "অব্যাহতির তারিখ",
      render: (releaseDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {releaseDate}
        </Text>
      ),
    },
    {
      id: 8,
      key: "joiningDate",
      name: "প্রতিষ্ঠানে যোগদানের তারিখ",
      render: (joiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {joiningDate}
        </Text>
      ),
    },
    {
      id: 9,
      key: "lastWorkingOfficeInfo",
      name: <Text className="text-nowrap">সর্বশেষ কর্মস্থলের নাম</Text>,
      render: (lastWorkingOfficeInfo: string) => (
        <Text color="subtitle1">{lastWorkingOfficeInfo}</Text>
      ),
    },
  ];
};
